import { createSelector } from 'reselect'

export default createSelector(
  state => state.background_processes.backup,
  (infos) => infos
  )
